// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__2KX-o","fail":"Button_fail__OT-aX","success":"Button_success__2mpg0","primary":"Button_primary___RBuP","margin_reset":"Button_margin_reset__2Ao7u"};